import api from "./apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async estadisticas() {
    const response = await api.post(API_URL + "estadisticas", {});
    if (response.data) return response.data;
  },
};
